/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import { forwardRef } from 'react'
import Icon from '../icon/icon'

const ArrowheadLeftIconSvg = forwardRef((props, svgRef) => (
	<svg
		data-name="Livello 1"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 24 24"
		width={props.width || (props.height && Math.floor(+props.height * 1)) || 24}
		height={props.height || (props.width && Math.floor(+props.width / 1)) || 24}
		fontSize="medium"
		ref={svgRef}
		{...props}
	>
		<path d="M14.5 6.5c.13 0 .26.05.35.15.2.2.2.51 0 .71l-4.65 4.65 4.65 4.65c.2.2.2.51 0 .71s-.51.2-.71 0l-5-5c-.2-.2-.2-.51 0-.71l5-5c.1-.1.23-.15.35-.15z" />
	</svg>
))
ArrowheadLeftIconSvg.displayName = 'ArrowheadLeftIconSvg'

const ArrowheadLeftIcon = forwardRef((props, ref) => <Icon component={ArrowheadLeftIconSvg} ref={ref} {...props} />)
ArrowheadLeftIcon.displayName = 'ArrowheadLeftIcon'

ArrowheadLeftIcon.defaultProps = {
	...Icon.defaultProps,
}
ArrowheadLeftIcon.propTypes = {
	...Icon.propTypes,
}

export default ArrowheadLeftIcon
export { ArrowheadLeftIconSvg }
